var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewbgactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 76,
    viewBox: "0 0 182 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.547 7.14189C76.1505 6.33765 86.0558 4.5281 91.5587 3.2212C100.263 1.00953 103.365 0.808467 115.571 1.11006C125.877 1.41165 131.78 2.11536 138.083 3.72385C142.786 4.93022 150.69 7.74507 155.593 9.95675C160.495 12.0679 166.999 15.5865 169.9 17.7981C172.702 20.0098 176.504 23.9305 178.205 26.6448C180.906 30.8671 181.206 32.0735 180.906 37.5021C180.706 42.026 179.906 44.6398 177.805 47.7562C176.304 50.0684 171.501 54.7934 167.199 58.2114C162.797 61.73 156.693 66.1533 153.492 68.0634C150.29 69.9735 144.687 72.3862 141.085 73.291C136.082 74.5979 129.979 75 114.571 75C103.565 75 83.3544 74.3968 69.547 73.5926C55.8397 72.7883 41.1319 71.582 37.0297 70.9788C32.9276 70.3756 26.1239 68.8676 22.0218 67.5607C17.9196 66.2538 12.5167 63.6401 10.0154 61.8305C7.51404 59.9204 4.51244 56.804 3.21175 54.8939C1.51084 52.2801 0.910525 50.0684 1.01058 45.444C1.01058 40.6186 1.6109 38.1053 4.21228 32.8777C6.21334 28.957 9.91531 23.9305 13.6173 20.3114C17.0191 16.9939 21.7216 13.2743 24.1229 12.1684C27.7248 10.3589 31.1266 9.85622 43.0329 9.35356C51.0372 8.95144 62.9435 8.04667 69.547 7.14189Z",
    fill: "white",
    stroke: "#1A2D9F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewbgactive);
export default __webpack_public_path__ + "static/media/newbgactive.69b22e3152cd96da893a5d0ba02abea8.svg";
export { ForwardRef as ReactComponent };